/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.1.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
 import Vue from "vue";
 import VueRouter from "vue-router";
 import App from "./App.vue";
 
 // LightBootstrap plugin
 import LightBootstrap from "./light-bootstrap-main";
 
 // router setup
 import store from './store';
 import router from "./routes/routes";
 
 import {
   ValidationObserver,
   ValidationProvider,
   extend,
   localize
 } from "vee-validate";
 
 import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
 
 //import "chart.js"
 
 //Vue.use(window.VueCharts);
 
 import axios from 'axios'
 
 import "./registerServiceWorker";
 
 import 'bootstrap-vue/dist/bootstrap-vue.css';
 
 import en from "vee-validate/dist/locale/en.json";
 import * as rules from "vee-validate/dist/rules";
 Vue.config.productionTip = false;
 Object.keys(rules).forEach(rule => {
   extend(rule, rules[rule]);
 });
 localize("en", en);
//  axios.defaults.baseURL = 'https://bmstest.tsehaybank.com.et:8443/BuildingManagementTest/'
//  axios.defaults.baseURL = 'http:///localhost:8086/'
 axios.defaults.baseURL = 'https://bms.tsehaybank.com.et:8443/BuildingManagement/';
 axios.defaults.headers.get["Accepts"] = 'application/json';
 axios.defaults.headers.get["Content-Type"] = 'application/json';                
 axios.defaults.headers.post['Content-Type'] = 'application/json';
 axios.defaults.headers.post['Accepts'] = 'application/json';

 // Add cache-busting headers
 axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
 axios.defaults.headers.common['Pragma'] = 'no-cache';
 axios.defaults.headers.common['Expires'] = '0';

 // Add request interceptor for cache busting (only register once)
 if (!window._axiosInterceptorRegistered) {
   window._axiosInterceptorRegistered = true;
   axios.interceptors.request.use(config => {
     const timestamp = sessionStorage.getItem('loginTimestamp') || Date.now();
     config.params = config.params || {};
     config.params._t = timestamp;
     return config;
   }, error => {
     return Promise.reject(error);
   });
 }

 let Fire  = new Vue();
 window.Fire = Fire;
 
 Vue.component("ValidationObserver", ValidationObserver);
 Vue.component("ValidationProvider", ValidationProvider);
 
 Vue.use(BootstrapVue)
 // plugin setup
 Vue.use(IconsPlugin)
 
 Vue.use(VueRouter);
 Vue.use(LightBootstrap);

 // Global mixin to force component refresh on login
 Vue.mixin({
   data() {
     return {
       forceRefreshKey: sessionStorage.getItem('loginTimestamp') || 0
     }
   },
   watch: {
     '$route'() {
       // Update refresh key when route changes after login
       const loginTimestamp = sessionStorage.getItem('loginTimestamp');
       if (loginTimestamp && loginTimestamp !== this.forceRefreshKey) {
         this.forceRefreshKey = loginTimestamp;
         this.$forceUpdate();
       }
     }
   }
 });
 
 import VueApexCharts from 'vue-apexcharts'
 Vue.use(VueApexCharts)
 
 Vue.component('apexchart', VueApexCharts)
 
 // configure router
 // const router = new VueRouter({
 //   routes, // short for routes: routes
 //   linkActiveClass: "nav-item active",
 //   scrollBehavior: (to) => {
 //     if (to.hash) {
 //       return { selector: to.hash };
 //     } else {
 //       return { x: 0, y: 0 };
 //     }
 //   },
 // });
 
 /* eslint-disable no-new */
 
 // Interceptors
 
 // axios.interceptors.response.use((response) => {
 //   return response
 // }, async function (error) {
 //   console.log("FromINterceptor", error);
 //   const originalRequest = error.config;
 //   if (error.response.status === 401 && !originalRequest._retry) {
 //     originalRequest._retry = true;
 //     var refreshed_token = '';
 //     await store.dispatch('renewAccessToken')
 //         .then( async result =>{
 //           if(result.status === 200 || result.status === 204){
 //             console.log("refreshed:",result.data.access_token);
 //             refreshed_token = 'Bearer '+ result.data.access_token;
 //           }
 //           else{
 //             return Promise.reject(Error("some shit happens"));
 //           }    
 //         })
 //         .catch(err => {
 //           console.log(err);
 //         }) 
 //         originalRequest.headers[
 //           "Authorization"
 //         ] = refreshed_token;
 //         //originalRequest.baseURL = undefined;        
 //     return axios.request(originalRequest);
 //   }
 //    return Promise.reject(error);
 // });
 
 axios.interceptors.response.use(
   function(response) {
     // Any status code that lie within the range of 2xx cause this function to trigger
     // Do something with response data
     return response;
   },
   // remember to make this async as the store action will 
   // need to be awaited
   async function(error) {
     // Any status codes that falls outside the range of 2xx cause this function to trigger
     // Do something with response error
     const originalRequest = error.config;
     //console.log("Refresh", error);
     if (
       error.response.status === 401 &&
       originalRequest.url.includes("/api/v1/auth/refresh")
     ) {
       //store.commit("clearUserData");
       router.push("/");
       return Promise.reject(error);
     } else if (error.response.status === 401 && !originalRequest._retry) {
       originalRequest._retry = true;
       // await execution of the store async action before 
       // return
       delete axios.defaults.headers.common["Authorization"];
       await store.dispatch('renewAccessToken')
         .then( async result =>{
           if(result.status === 200 || result.status === 204){
             //console.log("refreshed:",result.data.access_token);
             originalRequest.headers['Authorization']  = 'Bearer '+ result.data.access_token;
           }
           else{
             return Promise.reject(Error("some shit happens"));
           }    
         })
         .catch(err => {
           //console.log(err);
           router.push("/");
         }) 
         //return;
       return axios(originalRequest);
     }
     //console.log("From Inre",error.response);
     return Promise.reject(error);
   }
 );
 
 // Add event listeners to update last activity time
 document.addEventListener('mousemove', () => {
   store.commit('setLastActivityTime', Date.now());
 });
 document.addEventListener('keydown', () => {
   store.commit('setLastActivityTime', Date.now());
 });
 
 // Check for session expiration every minute (single interval, never duplicated)
 if (!window._sessionIntervalId) {
   window._sessionIntervalId = setInterval(() => {
     const idleTime = Date.now() - parseInt(store.state.lastActivityTime);
     if (idleTime >= 300000 && store.getters.loggedIn) {
       store.dispatch('logout');
       clearInterval(window._sessionIntervalId);
       window._sessionIntervalId = null;
     }
   }, 60000);
 }
 
 new Vue({
   el: "#app",
   render: (h) => h(App),
   router,
   store
 });
 